import { NOTA_MAXIMA } from '../constants/catalogoMomentos';
import type {
  MomentoPesquisa,
  OrigemPesquisa,
  RecursoPesquisa,
} from '../types/pesquisaSatisfacaoTypes';

/**
 * Congela onde a pesquisa nasceu, no instante em que o cartão aparece.
 *
 * A `rotaResolvida` vem do `usePathname()` e pode divergir da `rotaPadrao` do
 * catálogo: o momento é declarado com a rota canônica (`/notificacoes/lotes/[id]`),
 * mas a pessoa pode estar em outra tela quando o evento chega. As duas viajam
 * porque respondem perguntas diferentes — "de que ponto de contato é esta nota" e
 * "onde a pessoa estava".
 *
 * @example montarOrigem(momento, '/notificacoes/lotes/abc', { tipo: 'lote_notificacao', id: 'abc' })
 */
export function montarOrigem(
  momento: MomentoPesquisa,
  rotaResolvida: string | null,
  recurso: RecursoPesquisa | null,
): OrigemPesquisa {
  return {
    produto: momento.produto,
    fluxo: momento.fluxo,
    tela: momento.tela,
    rotaPadrao: momento.rotaPadrao,
    rotaResolvida,
    recursoTipo: recurso?.tipo ?? null,
    recursoId: recurso?.id ?? null,
    medida: momento.tipo,
    escalaMinimo: 1,
    escalaMaximo: NOTA_MAXIMA[momento.tipo],
    versaoCopy: momento.versaoCopy,
  };
}
